import { z } from 'zod';

import { LineMessageFormFieldsProps, LineMessageFormStoreProps } from '../../components';

export const LineMessageDialogFormFields = LineMessageFormFieldsProps.extend({
  title: z.string(),
});

export type LineMessageDialogFormFields = z.infer<typeof LineMessageDialogFormFields>;

export interface LineMessageDialogProps extends LineMessageFormStoreProps {
  /** On submit method */
  onSubmit: (props: {
    updatedDraftContent: string;
    lineMessageDialog: LineMessageDialogFormFields;
  }) => void;
  /** Method to execute on cancel */
  onCancel?: () => void;
  /** unit message id */
  messageId?: string;
  /** Initial values */
  initialValues?: LineMessageDialogFormFields;
}
